<button class="fab border-0 shadow" data-bs-toggle="modal" data-bs-target="#segment_modal" data-bs-dismiss="offcanvas">+</button>
<teleport to="body">
<div class="modal fade" id="segment_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title text-xs fw-500" id="exampleModalLabel">Create a Segment</p>
          <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="createSegment">
          <div class="modal-body">
  
            <div class="mb-3">
              <label for="topic_name" class="form-label text-xs fw-500">Segment Name <span
                  class="text-danger">*</span></label>
              <input type="text" class="form-control rounded-5 text-xs" id="topic_name" placeholder="Enter topic name"
                v-model="topic_name">
                <p v-if="errors.topic_name" class="text-danger text-xs">{{ errors.topic_name }}</p>
            </div>
  
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xs rounded-3 shadow-sm">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>

</teleport>  